import React, { useRef } from "react";
import AddButtonSection from './AddButtonSection';
import profile from '../../assets/images/no-picture.jpg';
import { showToast } from "./toast";
import { TOAST_TYPE, COMMON_MSG } from "../../constants/toast";

export default function AddImageSection({ showImg, setImg }) {
  const fileInputRef = useRef(null);

  const validateFile = (file) => {
    // Check file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
    if (!allowedTypes.includes(file.type)) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.INVALID_FILE_TYPE);
      return false;
    }

    // Check file size (800KB = 800 * 1024 bytes)
    const maxSize = 800 * 1024;
    if (file.size > maxSize) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.FILE_SIZE_EXCEEDED);
      return false;
    }

    return true;
  };

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    if (file && validateFile(file)) {
      setImg(file);
    } else {
      // Reset file input if validation fails
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleReset = () => {
    setImg(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const profileBtn = [
    {
      type: "primarySuccessButton",
      label: "Upload Photo",
      class: "col-8",
      onClick: handleUploadClick,
    },
    {
      type: "secondaryButton",
      label: "Reset",
      class: "col-4",
      onClick: handleReset,
    },
    {
      type: "render",
      render: (
        <div className="msgText font-normal text-xs p-2">
          Allowed JPG, GIF or PNG. Max size of 800K
        </div>
      ),
    },
  ];

  const getImageSrc = (showImg, profile) => {
    try {
      if (showImg instanceof File) return URL.createObjectURL(showImg);
      if (typeof showImg === "string" && showImg) return showImg;
      return profile;
    } catch {
      return profile;
    }
  };
  const imgSrc = getImageSrc(showImg, profile);
  return (
    <React.Fragment>
      <div className="pt-3 pb-3 grid">
        <div className="col-4">
          <img
            className="w-full h-[103px] border-round-lg"
            src={
              imgSrc
            }
            alt="Profile preview"
          />
        </div>
        <div className="col-8">
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
          />
          <AddButtonSection buttons={profileBtn} />
          {showImg && showImg.name && (
            <div className="mt-2 text-sm text-gray-600">
              Selected: {showImg.name}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}
